/** @jsx jsx */
import React from "react";
import { jsx, css } from "@emotion/core";
interface Props extends Omit<React.SVGProps<SVGSVGElement>, "css"> {
  weight?: "thin" | "normal";
}
export const IconVariant = React.forwardRef<SVGSVGElement, Props>(
  (
    { fill = "none", stroke = "currentColor", weight = "normal", ...props },
    ref,
  ) => (
    <svg
      viewBox="0 0 24 24"
      ref={ref}
      css={css`
        * {
          vector-effect: non-scaling-stroke;
        }
        overflow: visible;
        height: 24px;
      `}
      {...props}
    >
      <g
        fill={fill}
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={weight === "normal" ? 1.5 : 1}
      >
        <path d="M22.91 6.953L12.7 1.672a1.545 1.545 0 0 0-1.416 0L1.076 6.953a.615.615 0 0 0 0 1.094l10.209 5.281c.444.229.972.229 1.416 0L22.91 8.047a.616.616 0 0 0 0-1.094z" />
        <path d="M.758 12.75l10.527 5.078c.444.229.972.229 1.416 0l10.557-5.078" />
        <path d="M.758 17.25l10.527 5.078c.444.229.972.229 1.416 0l10.557-5.078" />
      </g>
    </svg>
  ),
);
